import { CustomFieldImport } from '../translations-types';

const translations: CustomFieldImport = {
  title: 'Klantlabel importeren via CSV',
  description:
    'Upload een CSV, kies een klantlabel en geef aan welke kolom de e-mailadressen bevat. Klanten die op e-mail matchen krijgen het klantlabel aangezet.',
  selectField: 'Klantlabel',
  selectFieldPlaceholder: 'Kies een klantlabel',
  uploadFile: 'CSV kiezen',
  fileContainsHeader: 'Eerste rij is kop',
  emailColumn: 'E-mailkolom',
  selectEmailColumn: 'Kies de e-mailkolom',
  column: 'Kolom',
  matched: 'Gevonden',
  alreadySet: 'Al aangezet',
  toSet: 'Worden aangezet',
  notFound: 'Niet gevonden',
  notFoundHint: 'Deze e-mailadressen uit de CSV komen niet voor in Re-sence.',
  apply: 'Toepassen',
  applied: 'Klanten bijgewerkt',
  parseError: 'Kan het CSV-bestand niet lezen.',
  emptyFile: 'Het bestand bevat geen regels.',
  noEmailInColumn: 'Geen e-mailadressen in deze kolom.',
};

export default translations;
